
export default {
    props: {
        href: {
            type: String,
            default: null,
        },
        baseUrl: {
            type: String,
            default: '',
        },
        external: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: null,
        },
    },
    computed: {
        /** @return {boolean} */
        _isSpa() {
            // @ts-ignore
            return this.$nuxt && !this._isExternal;
        },
        /** @return {boolean} */
        _isExternal() {
            return this.external || this.href?.startsWith('http');
        },
        /** @return {string | null} */
        _href() {
            if (this.disabled) {
                return null;
            }

            if (this._isSpa || this._isExternal) {
                return this.href;
            }

            const href = this.href && this.href !== '/' ? this.href : '';
            return this.baseUrl + href;
        },
    },
};
